import { render, staticRenderFns } from "./ProductRule.vue?vue&type=template&id=4ec285e4&scoped=true&"
import script from "./ProductRule.vue?vue&type=script&lang=js&"
export * from "./ProductRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec285e4",
  null
  
)

export default component.exports